// extracted by mini-css-extract-plugin
export var link = "BorderedLogo-module--link--gy1sV";